<div class="counter-container" [formGroup]="formGroup" [ngClass]="{'small': small}">
  <span class="title">{{label}}</span>
  <div class="counter-frame">
    <button class="button toggle-less" (click)="onClickLess()">
      <img src="assets/icons/minus.svg" alt="minus-btn" class="brand-icon" />
    </button>
    <div class="counter-input-field">
      <app-form-group
        id="count"
        formControlName="count"
        type="counter"
        [showIcons]="false"
        [errorMessages]="errorMessages[type]"
        [inputCentered]="true"
      ></app-form-group>
    </div>
    <button class="button toggle-more" (click)="onClickMore()">
      <img src="assets/icons/plus.svg" alt="plus-btn" class="brand-icon" />
    </button>
  </div>
</div>
